const accordion = require('./accordion');
const banner = require('./banner');
const footer = require('./footer');
const navigation = require('./navigation');
const password = require('./password');
const search = require('./search');
const skipnav = require('./skipnav');
const validator = require('./validator');

module.exports = {
  accordion,
  banner,
  footer,
  navigation,
  password,
  search,
  skipnav,
  validator,
};
